import { useParams } from 'react-router-dom';
import CreateAgentPage from './create-agent';

const DuplicateAgent = () => {
  const { id } = useParams();
  return <CreateAgentPage agentId={id} isDuplicate />;
};

export default DuplicateAgent;
